import React from 'react';
import logo from '../blueclan-logo.png';
import './Footer.css';

const footerLinks = {
  Services: ['AI Development', 'Web Development', 'App Development', 'UI/UX Design', 'Cloud Architecture'],
  Company:  ['About Us', 'Our Team', 'Case Studies', 'Blog', 'Careers'],
  Connect:  ['GitHub', 'LinkedIn', 'Twitter/X', 'Discord', 'YouTube'],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid-bg" />

      <div className="container footer-inner">
        {/* Brand col */}
        <div className="footer-brand">
          <a href="#home" className="footer-logo">
            <img src={logo} alt="BlueClan Logo" className="footer-logo-img" />
            <div>
              <div className="footer-brand-name">BLUE<span>CLAN</span></div>
              <div className="footer-brand-sub">ELITE TECHNOLOGY</div>
            </div>
          </a>

          <p className="footer-about">
            An elite collective of engineers and AI architects building the digital fortresses of tomorrow.
            We don't just write code — we engineer dominance.
          </p>

          <div className="footer-badge">
            <span className="fb-dot" />
            <span>Systems Operational · 99.9% Uptime</span>
          </div>
        </div>

        {/* Link cols */}
        {Object.entries(footerLinks).map(([group, links]) => (
          <div className="footer-col" key={group}>
            <h4 className="footer-col-title">{group}</h4>
            <ul className="footer-links">
              {links.map(l => (
                <li key={l}><a href="#" className="footer-link">{l}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span className="footer-copy">
            © {new Date().getFullYear()} BlueClan Technologies. All rights reserved.
          </span>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
          </div>
          <span className="footer-made">
            Built with <span className="heart">♦</span> by BlueClan
          </span>
        </div>
      </div>
    </footer>
  );
}
